/* eslint-disable */
import React from 'react'
import http from '../../Component/Interceptor/Interseptor'
import HeaderTable from '../BaseComponent/HeaderTable'
import Page from '../Pagination/Pagination'
import $ from 'jquery'
import {message} from 'antd'
import {Link} from 'react-router-dom'
import RETAIL from '../../Component/BaseComponent/RETAIL'
import jMoment from 'moment-jalaali'
import HeaderTablePrint from '../BaseComponent/HeaderTablePrint'
import A4Style from '../BaseComponent/printA4Style'
import cookie from 'react-cookies'
import REPORT_RETAIL from '../BaseComponent/REPORTRETAIL'
import SearchableCombo from '../BaseComponent/searchableCombo'
import ExcelExport from '@progress/kendo-react-excel-export/dist/npm/ExcelExport'
import Select from 'react-select'
import SearchProduct from '../BaseComponent/SearchProduct'
import FromToPicker from '../BaseComponent/FromToPicker'
import HeaderGrid from '../Pagination/HeaderGrid'
import Sort from '../Pagination/Sort'
import Pageing from '../Pagination/pageing'
import Loader from '../loaders/loader'

class PurchaseDeliveryPack extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: false,
      Providers: [],
      comboProvides: [],
      printInfo: [],
      lengthProviders: 0,
      pageNumber: 1,
      providerArr: [],
      providers: [],
      finalStocks: [],
      planDateMin: '',
      planDateMax: '',
      pageSize: 10,
      sortBy: '',
      getSort: '',
      sortData: [
        {
          name: 'ردیف',
          value: 'id',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'تاریخ تحویل',
          value: 'planDate',
          sorted: true,
          direction: null,
          sortable: true
        },
        {
          name: 'بازه تحویل',
          value: 'planTimeFrom',
          sorted: true,
          direction: null,
          sortable: true
        },
        {
          name: 'شماره فاکتور',
          value: 'invoiceNum',
          sorted: true,
          direction: null,
          sortable: true
        },
        {
          name: 'شناسه فاکتور',
          value: 'invoiceId',
          sorted: true,
          direction: null,
          sortable: true
        },
        {
          name: 'خریدار',
          value: 'buyerName',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'تحویل گیرنده',
          value: 'recipientName',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'موبایل',
          value: 'mobile',
          sorted: false,
          direction: null,
          sortable: false
        }
      ]
    }
  }

  componentDidMount() {
    http.get(`${REPORT_RETAIL.REPORT_RETAIL_LIST_PROVIDER}`, {}).then((response) => {
      if (response.data.error == null) {
        var provider = response.data.object
        for (let i = 0; i < provider.length; i++) {
          provider[i]['value'] = provider[i].providerId
          provider[i]['label'] = provider[i].providerId + ' - ' + provider[i].title
        }

        this.setState({
          providers: response.data.object
        })
      } else {
        this.setState({
          providers: []
        })
      }
    })

    sessionStorage.removeItem('params')

    $(function() {
      $('.filterBtn').on('click', function() {
        $('.filterComponent').slideToggle()
      })

      $('.cancelFilter').click(function() {
        $('.filterComponent').slideUp()
      })
    })
    sessionStorage.setItem('pageNumber', '1')
    sessionStorage.setItem('dropDownVal', '10')
  }
  getPurchaseDeliveryPack = (exportStatus) => {
    let filter = this.createFilter(exportStatus)
    this.setState({
      loading: true
    })
    http
      .get(`${RETAIL.REPORT_RETAIL_PURCHASE_DELIVERYPACK}`, {
        params: filter
      })
      .then((response) => {
        if (response.data.error === null) {
          $('.showBaseTable,.print').fadeIn()
          this.setState({
            Providers: response.data.object.result,
            lengthProviders: response.data.object.countAll,
            buttonClicked: true,
            loading: false
          })
        } else {
          $('.showBaseTable,.print').fadeOut()
          this.setState({
            Providers: [],
            lengthProviders: 0,
            loading: false
          })
          // message.error(response.data.description)
        }
      })
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevState.pageNumber !== this.state.pageNumber) {
      this.getPurchaseDeliveryPack(false)
    }
    if (prevState.pageSize !== this.state.pageSize) {
      this.getPurchaseDeliveryPack(false)
    }
    if (prevState.sortBy !== this.state.sortBy) {
      this.getPurchaseDeliveryPack(false)
    }
  }
  getPageNumber = (pageNumber) => {
    this.setState({
      pageNumber
    })
  }

  getPageSize = (pageSize) => {
    this.setState({
      pageSize,
      pageNumber: 1
    })
  }

  getSort = (sortBy) => {
    this.setState({
      sortBy
    })
  }

  onResultFetched(data) {
    this.setState({
      Providers: data
    })
  }

  changeDropDown(data) {
    this.setState({
      Providers: data,
      lengthProducts: sessionStorage.getItem('countAll')
    })
  }
  createFilter = (exportStatus) => {
    let filter = {}
    let {finalStocks} = this.state
    let planDateMin = this.state.planDateMin
    let planDateMax = this.state.planDateMax

    filter.pageNumber = this.state.pageNumber
    filter.pageSize = this.state.pageSize
    filter.export = exportStatus
    if (this.state.sortBy !== '') {
      filter.sortBy = this.state.sortBy
    }

    if (finalStocks.length !== 0) {
      filter.stockProductIds = finalStocks.join(',')
    }

    if (planDateMin !== '') {
      filter.planDateMin = planDateMin
    }

    if (planDateMax !== '') {
      filter.planDateMax = planDateMax
    }

    return filter
  }

  filter() {
    if (Object.keys(this.createFilter(false)).length - 3 === 0) {
      message.error('حداقل یک فیلتر وارد شود')
    } else {
      this.setState(
        {
          pageNumber: 1
        },
        () => {
          this.getPurchaseDeliveryPack(false)
        }
      )
    }
  }

  exportExcel = () => {
    let filter = this.createFilter(true)
    http
      .get(`${RETAIL.REPORT_RETAIL_PURCHASE_DELIVERYPACK}`, {
        params: filter
      })
      .then((response) => {
        if (response.data.error == null) {
          sessionStorage.setItem('countAll', response.data.object.countAll)
          this.setState({
            excelReport: response.data.object.result
          })
          let {excelReport} = this.state
          for (let i = 0; i < excelReport.length; i++) {
            excelReport[i]['planDate'] = jMoment(excelReport[i]['planDate']).format('jYY/jMM/jDD HH:mm')
          }
          this._export.save(this.state.excelReport)
        } else {
          this.setState({
            excelReport: []
          })
        }
      })
      .catch((error) => {})
  }

  getPrintInfo = () => {
    let filter = this.createFilter(true)
    this.setState({
      loading: true
    })
    http
      .get(`${RETAIL.REPORT_RETAIL_PURCHASE_DELIVERYPACK}`, {
        params: filter
      })
      .then((response) => {
        console.log(response)

        if (response.data.error == null) {
          sessionStorage.setItem('countAll', response.data.object.countAll)

          this.setState({
            printInfo: response.data.object.result,
            loading: false
          })
          setTimeout(() => {
            window.print()
          }, 2000)
        } else {
          this.setState({
            printInfo: [],
            loading: false
          })
        }
      })
      .catch((error) => {
        alert(JSON.stringify(error))
        this.setState({
          loading: false
        })
      })
  }

  exportPrint = () => {
    var css = '@page { size:A4 portrait;}',
      head = document.head || document.getElementsByTagName('head')[0],
      style = document.createElement('style')

    style.type = 'text/css'
    style.media = 'print'

    if (style.styleSheet) {
      style.styleSheet.cssText = css
    } else {
      style.appendChild(document.createTextNode(css))
    }

    head.appendChild(style)
    this.getPrintInfo()
  }

  handleChangeProvider = (multiProvider) => {
    var providerArr = []
    this.setState({multiProvider})
    if (multiProvider.length == '0') {
      this.setState({
        providerArr: []
      })
    } else {
      for (let prop of multiProvider) {
        providerArr.push(prop.providerId)
        this.setState({
          providerArr: providerArr
        })
      }
    }
  }

  getStocks = (arrayOfStocks) => {
    var stockArr = []

    this.setState({
      arrayOfStocks
    })

    if (arrayOfStocks.length == '0') {
      this.setState({
        finalStocks: []
      })
    } else {
      for (let prop of arrayOfStocks) {
        stockArr.push(prop.value)
        this.setState({
          finalStocks: stockArr
        })
      }
    }
  }

  finalStocks = (finalStocks) => {
    let array = []
    finalStocks.forEach((item) => {
      array.push(item.stockProductId)
    })
    this.setState({
      finalStocks: array
    })
  }

  handleChangeFrom = (planDateMin) => {
    this.setState({
      planDateMin
    })
  }

  handleChangeTo = (planDateMax) => {
    this.setState({
      planDateMax
    })
  }

  render() {
    let {pageNumber, pageSize, loading} = this.state
    let excelColumns = [
      {title: 'نام تامین کننده', value: 'title'},
      {title: 'شناسه تامین کننده', value: 'providerId'},
      {title: 'کد ملی', value: 'nationalId'},
      {title: 'کد اقتصادی', value: 'economicCode'}
    ]
    let name = cookie.load('name')
    let columns = [
      'ردیف',
      'تاریخ تحویل',
      'بازه تحویل',
      'شماره فاکتور',
      'شناسه فاکتور',
      'خریدار',
      'تحویل گیرنده',
      'موبایل'
    ]
    let urlParams = sessionStorage.getItem('params')

    return (
      <div className="rtl printA4Page">
        <Loader show={loading} />
        <div className="printSection">
          <table className="printTable printReportTable" ref={(node) => (this.printPart = node)}>
            <HeaderTablePrint
              header="گزارش اشانتیون پارت تحویل"
              headerColSpan={8}
              reporter={name}
              timePrint={jMoment().format('jYYYY/jM/jD HH:mm')}
              leftColSpan={3}
              rightColSpan={4}
              centerColSpan={1}
              centerSection={''}
              rightSection={' تاریخ از : ' + this.state.fromPrintDate + ' تا : ' + this.state.toPrintDate}
              columns={columns}
            />
            <tbody>
              {this.state.printInfo.map((providers, index) => (
                <tr key={'i' + index}>
                  <td>{index + 1}</td>
                  <td>{jMoment(providers.planDate).format('jYYYY/jMM/jDD')}</td>
                  <td>{providers.planTimeFrom.substr(0, 5) + ' - ' + providers.planTimeTo.substr(0, 5)}</td>
                  <td>{providers.invoice.invoiceNum}</td>
                  <td>{providers.invoice.invoiceId}</td>
                  <td>{providers.invoice.buyerName}</td>
                  <td>{providers.invoice.recipientName}</td>
                  <td className="">
                    {providers.invoice.mobile == null ? '-' : providers.invoice.mobile.replace(/\+98/g, '0')}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="excelSection">
          <ExcelExport
            dir="rtl"
            ref={(exporter) => {
              this._export = exporter
            }}
            fileName="گزارش اشانتیون پارت تحویل.xls"
          >
            <grid style={{height: '420px'}} data={this.state.excelReport}>
              <gridColumn
                key={'planDate'}
                field={'planDate'}
                title={'تاریخ'}
                width="250px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'planTimeFrom'}
                field={'planTimeFrom'}
                title={'بازه تحویل از'}
                width="150px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'planTimeTo'}
                field={'planTimeTo'}
                title={'بازه تحویل تا'}
                width="150px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'invoiceNum'}
                field={'invoice.invoiceNum'}
                title={'شماره فاکتور'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'invoiceId'}
                field={'invoice.invoiceId'}
                title={'شناسه فاکتور'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'buyerName'}
                field={'invoice.buyerName'}
                title={'خریدار'}
                width="200px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'recipientName'}
                field={'invoice.recipientName'}
                title={'تحویل گیرنده'}
                width="200px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'mobile'}
                field={'invoice.mobile'}
                title={'موبایل'}
                width="200px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
            </grid>
          </ExcelExport>
        </div>

        <div className="wrapperIframe">
          <ul className="breadcrumb">
            <li>
              <Link to={'/search'}>به روزرسان</Link>
            </li>
            <li>گزارشات</li>
            <li>خرید و فروش</li>
            <li>اشانتیون پارت تحویل</li>
          </ul>
          <div className="tableComponent">
            <div className="tableTools">
              <div className="tableOptionWrapp">
                <HeaderGrid
                  getPageSize={this.getPageSize}
                  createLink={'/report/purchase/deliveryPack'}
                  enablePageSize
                />
                <button className="filterBtn">
                  <i className="fa fa-search" />
                </button>
                <button
                  className={'printButton'}
                  disabled={this.state.buttonClicked ? false : true}
                  onClick={this.exportExcel}
                >
                  <i className="fas fa-file-excel" />
                </button>
                <button
                  className="printButton"
                  disabled={this.state.buttonClicked ? false : true}
                  onClick={this.exportPrint}
                >
                  <i className="fas fa-print" />
                </button>
              </div>
            </div>
            <div className="basketFilterComponent">
              <div className="filterInputs">
                <FromToPicker
                  force
                  onChangeFromDate={this.handleChangeFrom}
                  onChangeToDate={this.handleChangeTo}
                  fromLabel="تاریخ از"
                  toLabel="تاریخ تا"
                  defaulValue={true}
                  fromId="planDateMin"
                  toId="planDateMax"
                />

                {/*<div className='formComponent'>*/}
                {/*<label>تامین کننده ها :</label>*/}
                {/*<Select*/}
                {/*value={this.state.multiProvider}*/}
                {/*onChange={this.handleChangeProvider}*/}
                {/*options={this.state.providers}*/}
                {/*isMulti={true}*/}
                {/*isClearable={true}*/}
                {/*placeholder=''*/}
                {/*/>*/}
                {/*</div>*/}
              </div>
              <div>
                <SearchProduct getStocks={this.getStocks} finalStocks={this.finalStocks} />
              </div>
              <div className="filterOption">
                <button className="confirmFilter" onClick={this.filter.bind(this)}>
                  جست و جو
                </button>
              </div>
            </div>

            <div className="showBaseTable print">
              <table className="baseTable">
                <tbody>
                  <Sort data={this.state.sortData} getSort={this.getSort} />
                  {this.state.Providers.map((providers, index) => (
                    <tr key={index}>
                      <td>{(pageNumber - 1) * pageSize + index + 1}</td>
                      <td>{jMoment(providers.planDate).format('jYYYY/jMM/jDD')}</td>
                      <td>{providers.planTimeFrom.substr(0, 5) + ' - ' + providers.planTimeTo.substr(0, 5)}</td>
                      <td>{providers.invoice.invoiceNum}</td>
                      <td>{providers.invoice.invoiceId}</td>
                      <td>{providers.invoice.buyerName}</td>
                      <td>{providers.invoice.recipientName}</td>
                      <td className="">
                        {providers.invoice.mobile == null ? '-' : providers.invoice.mobile.replace(/\+98/g, '0')}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <div className="paginationWrapp">
                <Pageing
                  defaultCurrent={1}
                  getPage={this.getPageNumber}
                  pageSize={this.state.pageSize}
                  currentPage={this.state.pageNumber}
                  total={this.state.lengthProviders}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default PurchaseDeliveryPack
